import React, { useEffect } from "react";
import "./Home.css";
import proImg from "../img/Pro Pic small.jpg";
import Img from "../img/proImg.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoffee,
  faCodeBranch,
  faLink,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import code from "../img/codeOne.png";

import { Link } from "react-router-dom";

import aos from "aos";
import "aos/dist/aos.css";

const Home = () => {
  document.title = "💻 Rian Islam";

  useEffect(() => {
    aos.init({ duration: 2000 });
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-2 col-lg-2 col-sm-2"></div>
        <div className="col-md-8 col-lg-8 col-sm-12">
          <div className="space"></div>
          <div data-aos="fade-down" className="img">
            <img  src={Img} alt="" />
          </div>
          <div  className="name">
            <h1 data-aos="fade-right"  className="display-4">Rian Islam</h1>
            <h3 data-aos="fade-left" >Full-Time Coder & Web Developer</h3>
            <p data-aos="fade-right" >I like to make web Applications.Mostly React Js & Node Js</p>
          </div>
          <div data-aos="fade-up"  className="someLinks">
            <h4 className="pe-3">
              <FontAwesomeIcon icon={faCodeBranch} />
              <a target="_blank" href="https://github.com/RianIslam">
                Github
              </a>
            </h4>
            <h4 className="pe-3">
              <FontAwesomeIcon icon={faLink} />
              <a target="_blank" href="https://www.linkedin.com/in/rian-islam/">
                LinkedIn
              </a>
            </h4>
            <h4>
              <FontAwesomeIcon icon={faDownload} />
              <a
                target="_blank"
                href="https://drive.google.com/file/d/1ICbuanBndVuiICkl9kzv7LdLpz0mSdzh/view"
              >
                Resume
              </a>
            </h4>
          </div>
          <div className="space-end"></div>
        </div>
        <div className="col-md-2 col-lg-2 col-sm-2"></div>
      </div>
    </div>
  );
};

export default Home;
